import { Injectable } from '@angular/core';
import {School} from '../../application/web-components/models/school';

@Injectable()
// tslint:disable-next-line:class-name
export class Student_questionnaire_sharedService {
  private _schoolIds: any = '';
  private _schoolLabel = '';
  private _academicYear = '';
  private _listSchools: School[] = [];

  get schoolIds(): any {
    return this._schoolIds;
  }

  set schoolIds(ids: any) {
    this._schoolIds = ids;
  }

  get schoolLabel(): string {
    return this._schoolLabel;
  }

  set schoolLabel(label: string) {
    this._schoolLabel = label;
  }

  get academicYear(): string {
    return this._academicYear;
  }

  set academicYear(value: string) {
    this._academicYear = value;
  }

  get listSchools(): School[] {
    return this._listSchools;
  }

  set listSchools(value: School[]) {
    this._listSchools = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/student_questionnaire_shared.service.ts